import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './NavigationLinks.module.less';
import SectionLinkItem from './SectionLinkItem';

const NavigationLinks = ({ links, hideSubmenu }) => {
  if (!links || links.length === 0) return null;

  // fundera pillarnav
  const pillarList = links;
  return (
    <ul className={styles.list}>
      {pillarList.map(section => (
        <SectionLinkItem
          section={section}
          hideSubmenu={hideSubmenu}
          key={section.name}
        />
      ))}
    </ul>
  );
};

NavigationLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  hideSubmenu: PropTypes.bool,
};

NavigationLinks.defaultProps = {
  links: null,
  hideSubmenu: false,
};

export default NavigationLinks;
